import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const DisplayNameField = ({ id, value, onChange, onKeyDown }) => <div className="min-w-0 space-y-1">
  <Label htmlFor={id} className="text-xs text-muted-foreground" data-testid={`${id}-label`}>Display name <span className="font-normal">(optional)</span></Label>
  <Input id={id} value={value || ""} onChange={event => onChange(event.target.value)} onKeyDown={onKeyDown} maxLength={120} autoComplete="off" placeholder="Same as name if blank" data-testid={id} />
</div>;